import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchCurrentUserPathProgresses,
  selectCurrentUser,
} from 'features/auth/slice';

import { Heading, Image, Jumbotron } from '@frontendmentorio/design-system-v2';

import LearningPathCard from './Card';

export default function Index({ paths }) {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);

  useEffect(() => {
    if (!currentUser) return;

    dispatch(fetchCurrentUserPathProgresses());
  }, [currentUser?.id]);

  return (
    <>
      <Jumbotron className="pt-7 px-5 tablet:pt-0">
        <div className="container-sm flex flex-col gap-6 items-center tablet:container-xl tablet:flex-row">
          <div className="flex flex-col gap-5 items-center text-center tablet:items-start tablet:min-w-[30rem] tablet:text-start tablet:w-1/2">
            <Heading className="text-blue-500" level="1">
              Learning paths
            </Heading>

            <p className="text-neutral-500 text-lg">
              Our learning paths help you improve your front-end skills step by
              step. Each path covers a different topic, guiding you through
              essential front-end development topics to become a skilled
              developer.
            </p>
          </div>

          <Image
            alt=""
            className="max-w-[30rem] w-full tablet:max-w-none tablet:w-1/2"
            height={1172}
            priority
            src="/static/images/learning-paths-hero.webp"
            width={1200}
          />
        </div>
      </Jumbotron>

      <div className="bg-gray-100 pb-6 pt-8 px-5">
        <div className="container-lg flex flex-col gap-5">
          <ul className="flex flex-col gap-5">
            {paths.map((path) => (
              <LearningPathCard key={path.id} path={path} />
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
